import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { KNOWLEDGE_BASE_SECTIONS, KnowledgeBaseResource } from './knowledge-base.config';

import './styles.scss';

const KnowledgeBase = () => {
  const renderCard = (resource: KnowledgeBaseResource) => (
    <a
      className="kb-card"
      key={resource.url}
      href={resource.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${resource.title} (opens in a new tab)`}
    >
      <div className={`kb-card-icon kb-card-icon--${resource.type}`}>
        <FontAwesomeIcon icon={resource.icon} />
      </div>
      <div className="kb-card-body">
        <div className="kb-card-title">{resource.title}</div>
        <div className="kb-card-description">{resource.description}</div>
      </div>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="kb-card-external" />
    </a>
  );

  return (
    <div className="knowledge-base-container">
      <h1 className="title">Knowledge Base</h1>
      {KNOWLEDGE_BASE_SECTIONS.map((section) => (
        <div className="kb-section" key={section.title}>
          <div className="kb-section-header">
            <h2 className="kb-section-title">{section.title}</h2>
            <span className="kb-section-subtitle">{section.subtitle}</span>
          </div>
          <div className="kb-card-grid">{section.resources.map(renderCard)}</div>
        </div>
      ))}
    </div>
  );
};

export default KnowledgeBase;
